import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-helpbutton-reports-assistancequeryaveragetimemillis-card',
  templateUrl: './helpbutton-reports-assistancequeryaveragetimemillis-card.component.html',
  styleUrls: ['./helpbutton-reports-assistancequeryaveragetimemillis-card.component.scss']
})
export class HelpbuttonReportsAssistancequeryaveragetimemillisCardComponent implements OnInit {

  @Input() value;

  constructor() { }

  ngOnInit() {
  }

}
